module.exports = __webpack_public_path__ + "static/media/pers-foto-c.85216ceb.jpg";